import useGetUnresolvedComplaintByProductId from './useGetUnresolvedComplaintByProductId'

export default useGetUnresolvedComplaintByProductId
